import { appSettingsCustomAttributesData } from "@dashboardApi/apis/appSettingsCustomAttributesData";
import { appSettingsCustomAttributesTags } from "@dashboardApi/apis/appSettingsCustomAttributesTags/constants";

import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdCustomAttributesSettingsCacheKeys: AllRouteEndpoints[] = [
  appSettingsCustomAttributesData,
  appSettingsCustomAttributesTags,
];
